export const licenseeParams = {
    documentSchemas: [
        "*"
    ],
    repository: "default",
    providerName: "Licensee",
    pageProviderName: "Licensee",
    page: "0",
    pageSize: "50",
    searchTermTmpl: "dc:title ilike '%?%'",
    searchTerm: "dc:title ilike '%%'"
}

export const contractParams = {
    documentSchemas: [
        "*"
    ],
    page: 0,
    pageProviderName: "ContractES",
    pageSize: 20,
    providerName: "ContractES",
    queryParams: "ecm:fulltext.dc:title = \"*\"",
    queryParamsTmpl: "ecm:fulltext.dc:title = \"?*\"",
    repository: "default",
    searchTerm: ""
}

export const territoriesParams = {
    contains: true,
    dbl10n: false,
    documentId: "d662d692-9ebe-4fab-9504-b198ae6b4d60",
    field: "contract:territory",
    lang: "en",
    localize: true,
    searchTerm: "",
}

export const propertyParams = {
    contains: true,
    dbl10n: false,
    documentId: "d662d692-9ebe-4fab-9504-b198ae6b4d60",
    field: "contract:season",
    lang: "en",
    localize: true,
    searchTerm: ""
}

export const teirOfDistributionParams = {
    contains: true,
    dbl10n: false,
    directoryName: "tierOfDistribution",
    lang: "en",
    localize: true,
    searchTerm: "",
}

export const itemTypeParams = {
    contains: true,
    dbl10n: false,
    directoryName: "itemType",
    lang: "en",
    localize: true,
    searchTerm: ""
}

export const retailerParams = {
    contains: true,
    dbl10n: false,
    directoryName: "wbcpRetailer",
    lang: "en",
    localize: true,
    searchTerm: ""
}

export const consumerTargetParams = {
    contains: true,
    dbl10n: false,
    directoryName: "consumerTarget",
    lang: "en",
    localize: true,
    searchTerm: ""
}

export const packageTypeParams = {
    contains: true,
    dbl10n: false,
    directoryName: "packageType",
    lang: "en",
    localize: true,
    searchTerm: ""
}
export const submissionTypeParams = {
    contains: true,
    dbl10n: false,
    directoryName: "submissionType",
    lang: "en",
    localize: true,
    searchTerm: ""
}

export const seasonParams = {
    contains: true,
    dbl10n: false,
    directoryName: "inMarketSeason",
    lang: "en",
    localize: true,
    searchTerm: ""
}

export const deliveryTypeParams = {
    contains: true,
    dbl10n: false,
    directoryName: "deliveryType",
    lang: "en",
    localize: true,
    searchTerm: ""
}

export const productDetailParams = {
    contains: true,
    dbl10n: false,
    documentId: "d662d692-9ebe-4fab-9504-b198ae6b4d60",
    field: "contract:productDetail",
    lang: "en",
    localize: true,
    searchTerm: ""
}

export const originalAssetSeasonParams = {
    documentId: "acead133-c8da-4d20-8762-f7b0ee5a9b2f",
    searchTerm: ""
}

export const assetFileNameParams = {
    documentSchemas: [
        "*"
    ],
    page: 0,
    pageProviderName: "WBCPAssetSearchPublic",
    pageSize: 20,
    providerName: "WBCPAssetSearchPublic",
    queryParams: "public:theme != \"Style Guide Package\" and public:theme != \"00. Printable Styleguide\" and public:theme != \"00. Printable Style Guides\" and public:theme != \"Brand Assurance Guidelines\" and admin:publishYn = 1 AND (admin:wbcpRegionGroup IS NULL) AND (admin:licenseeCodeGroup IS NULL) AND (public:property IS NULL OR public:property = \"acead133-c8da-4d20-8762-f7b0ee5a9b2f\") AND ecm:fulltext.dc:title = \"*\"",
    queryParamsTmpl: "public:theme != \"Style Guide Package\" and public:theme != \"00. Printable Styleguide\" and public:theme != \"00. Printable Style Guides\" and public:theme != \"Brand Assurance Guidelines\" and admin:publishYn = 1 AND (admin:wbcpRegionGroup IS NULL) AND (admin:licenseeCodeGroup IS NULL) AND (public:property IS NULL OR public:property = \"acead133-c8da-4d20-8762-f7b0ee5a9b2f\") AND ecm:fulltext.dc:title = \"?*\"",
    repository: "default",
    searchTerm: ""
}

export const characterParams = {
    contains: true,
    dbl10n: false,
    documentId: "9eef6585-46b9-4012-ae5d-48f591c51ae2",
    field: "property_schema:character",
    lang: "en",
    localize: true,
    searchTerm: ""
}

export const associatedParams = {
    documentSchemas: ["*"],
    repository: "default",
    providerName: 'Submission',
    pageProviderName: 'Submission',
    page: 0,
    pageSize: 20,
    searchTermTmpl: "dc:title ilike '%?%'",
    searchTerm: "dc:title ilike '%%'"
}

export const locationParams = {
    documentSchemas: ["*"],
    repository: "default",
    providerName: 'Location',
    pageProviderName: 'Location',
    page: 0,
    pageSize: 20,
    searchTermTmpl: "dc:title ilike '%?%'",
    searchTerm: "dc:title ilike '%%'"
}
export const areaParams = {
    documentSchemas: ["*"],
    repository: "default",
    providerName: 'Area',
    pageProviderName: 'Area',
    page: 0,
    pageSize: 20,
    searchTermTmpl: "dc:title ilike '%?%'",
    searchTerm: "dc:title ilike '%%'"
}
export const attractionParams = {
    documentSchemas: ["*"],
    repository: "default",
    providerName: 'Attraction',
    pageProviderName: 'Attraction',
    page: 0,
    pageSize: 20,
    searchTermTmpl: "dc:title ilike '%?%'",
    searchTerm: "dc:title ilike '%%'"
}
export const carouselParams = {
    documentSchemas: "dublincore,carousel",
    providerName: "Carousel",
    pageProviderName: "Carousel",
    pageSize: 50
}